export class FileBeneficiary {
  private file: File;
  private fiscalNumber: string;

  static isCsvExtension(file: File): boolean {
    return file.name.includes(".csv");
  }

  getFile(): File {
    return this.file;
  }

  setFile(file: File): void {
    this.file = file;
  }

  getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  setFiscalNumber(value: string): void {
    this.fiscalNumber = value;
  }

  hasFile(): boolean {
    return !!(this.file && this.fiscalNumber);
  }
}
